module.exports = __webpack_public_path__ + "static/media/41.4034ebc8.jpg";